import React from "react";
import checkMark from "../../images/Svg/CheckMark.svg";
import Round from "../../images/Svg/Round.svg";
import BlackCheck from "../../images/Svg/BlackCheck.svg";
import CheckRound from "../../images/Svg/CheckRound.svg";
import { GrFormClose } from "react-icons/gr";
import { Fade } from "react-reveal";

const IncludeTweetComponent = ({
  title,
  description,
  includeHash,
  handleInTweet,
  handleSubmit,
  setIncludeHashtag,
  includeHashes,
  handleDelete,
  setIncludeHashes,
  setIncludeHashRetweet,
  includeHashRetweet,
  setIncludeHashQRet,
  includeHashQRet,
  includeHashtag,
  id,
  option,
}) => {
  return (
    <Fade cascade duration={1000}>
      <div>
        <div
          className={`${
            includeHash
              ? "bg-[#F6F7FF] border-[#5463FF] border-[2px]"
              : "bg-[#FFFFFF] border border-[#E1E1E1]"
          } ${
            option == "twitter"
              ? "min-h-[326px] sm:min-h-[326px] md:min-h-[460px]"
              : "min-h-[289px]"
          } card cursor-pointer mx-auto up_hover`}
        >
          <div
            onClick={handleInTweet}
            className="flex items-center cursor-pointer"
          >
            <img
              className="mx-5"
              src={includeHash ? CheckRound : Round}
              alt=""
            />
            <h5>{title}</h5>
          </div>
          <div className="border-b border-[#E1E1E1]  mt-[8px]"></div>
          <form
            onSubmit={(event) =>
              handleSubmit(
                event,
                includeHashes,
                includeHashtag,
                setIncludeHashes,
                id
              )
            }
            className="flex_card_style border border-[#E1E1E1] rounded-[8px]  py-2 px-4 mt-[16px] bg-[#FFFFFF]"
          >
            <input
              name="hashtag"
              onChange={(e) => setIncludeHashtag(e.target.value)}
              className="bg-[#FFFFFF] w-[100%]"
              id={id}
              placeholder={option == "twitter" ? "hashtag" : "Enter tags"}
              type="text"
              required
            />
            <button
              type="submit"
              className="add-button bg-[#5463FF] text-white"
            >
              Add
            </button>
            {/* update code */}
          </form>
          <p className="text-[16px] mt-[8px]">
            {option == "twitter" ? "Tweets" : "Blogs"} sent to DeSo will{" "}
            {description} the following{" "}
            {option == "twitter" ? "hastags" : "tags"}
          </p>
          <div className="flex flex-wrap items-center mt-[16px]">
            {includeHashes.map((hashtag, index) => (
              <button
                key={index}
                className={` add-button bg-[#E9EBFF] text-black m-2 items-center`}
              >
                {hashtag}

                <GrFormClose
                  onClick={() =>
                    handleDelete(hashtag, includeHashes, setIncludeHashes)
                  }
                />
              </button>
            ))}
          </div>

          {option === "twitter" && (
            <>
              <div
                onClick={() => setIncludeHashRetweet(!includeHashRetweet)}
                className="flex_card_style  pt-[40px] cursor-pointer"
              >
                <img src={includeHashRetweet ? checkMark : BlackCheck} alt="" />
                <p className="text-[16px] text-[#161616] cursor-pointer ml-[16px]">
                  Including Retweets
                </p>
              </div>
              <div
                onClick={() => setIncludeHashQRet(!includeHashQRet)}
                className="flex_card_style pt-[25px] cursor-pointer"
              >
                <img src={includeHashQRet ? checkMark : BlackCheck} alt="" />
                <p className="text-[16px] text-[#161616] cursor-pointer ml-[16px]">
                  Including Quote tweets
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </Fade>
  );
};

export default IncludeTweetComponent;
